import * as React from "react";
import { TextField } from "office-ui-fabric-react/lib/TextField";
import { Fabric } from "office-ui-fabric-react/lib/Fabric";
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from "office-ui-fabric-react/lib/DetailsList";
import { MarqueeSelection } from "office-ui-fabric-react/lib/MarqueeSelection";
import { mergeStyleSets } from "office-ui-fabric-react/lib/Styling";
import { CommandBar } from "office-ui-fabric-react/lib/CommandBar";
import { MyContext } from "../../../context";
import { Dialog, DialogType } from "office-ui-fabric-react/lib/Dialog";
import zipcelx from "zipcelx";
import TicketListOverlay from "./TicketListOverlay";
import SettingsColumnsTicket from "./SettingsColumnsTicket";
import { queryGetLoggedUserData } from "../../../queries/querySettings";
import FilterPanelTicket from "./FilterPanelTicket";
import { Icon } from "office-ui-fabric-react/lib/Icon";

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: "16px",
    },
    fileIconCell: {
        textAlign: "center",
        selectors: {
            "&:before": {
                content: ".",
                display: "inline-block",
                verticalAlign: "middle",
                height: "100%",
                width: "0px",
                visibility: "hidden",
            },
        },
    },
    fileIconImg: {
        verticalAlign: "middle",
        maxHeight: "20px",
        maxWidth: "20px",
    },
    controlWrapper: {
        display: "flex",
        flexWrap: "wrap",
    },
    exampleToggle: {
        display: "inline-block",
        marginBottom: "10px",
        marginRight: "30px",
    },
    selectionDetails: {
        marginBottom: "20px",
    },
});

const config = {
    filename: "TenantReport",
    sheet: {
        data: [
            [
                {
                    value: "Title",
                    type: "string",
                },
                {
                    value: "Created",
                    type: "string",
                },
                {
                    value: "Last Changed",
                    type: "string",
                },
                {
                    value: "Closed Date",
                    type: "string",
                },
                {
                    value: "Priority",
                    type: "string",
                },
                {
                    value: "CaseId",
                    type: "string",
                },
                {
                    value: "State",
                    type: "string",
                },
                {
                    value: "TenantId",
                    type: "string",
                },
                {
                    value: "Description",
                    type: "string",
                },
                {
                    value: "Contact Email",
                    type: "string",
                },
                {
                    value: "Tenant Name",
                    type: "string",
                }
            ],
        ],
    },
};

export interface IDetailsListDocumentsExampleState {
    columns: IColumn[];
    selectionDetails: string;
    isModalSelection: boolean;
    isCompactMode: boolean;
}

export default class UserList extends React.Component<{}, IDetailsListDocumentsExampleState> {
    _selection: Selection;
    _allItems: [];
    defaultSettingsColumns = ["caseId", "priority", "state", "changedMs", "title", "createdMs", "description", "contactEmail", "userId", "tenantId"];

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails(),
                });
            },
        });

        this.TicketListOverlayRef = React.createRef();

        this.state = {
            allColumns: [],
            columns: [],
            settingsColumns: [],
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: false,
            isCompactMode: true,
            items: this._allItems,
            filter: "",
            isDialogOpen: false,
            filterPanelOpen: false,
        };
    }
    async componentDidMount() {
        let auth = this.props.authorization;
        let result = await this.props.apol.query({
            query: queryGetLoggedUserData,
            variables: { auth },
        });
        let user = result.data.getLoggedUserData;
        let settingsColumns = user === null || user.listTicketSettings === null ? this.defaultSettingsColumns : user.listTicketSettings;
        console.log(settingsColumns)
        let columns: IColumn[] = [
            {
                key: "column2",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketCaseId")}</>}</MyContext.Consumer>,
                isResizable: true,
                fieldName: "caseId",
                minWidth: 110,
                maxWidth: 140,
                onColumnClick: this._onColumnClick,
            },
            {
                key: "column3",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketPriority")}</>}</MyContext.Consumer>,
                fieldName: "priority",
                minWidth: 60,
                maxWidth: 60,
                isResizable: true,
                data: "string",
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return (
                        <span>{item.priority === "SOS" ? "SOS" : item.priority === "Critical" ? "Prio 1" : item.priority === "Major" ? "Prio 2" : "Prio 3"}</span>
                    );
                },
            },
            {
                key: "column4",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketState")}</>}</MyContext.Consumer>,
                isResizable: true,
                fieldName: "state",

                minWidth: 80,
                maxWidth: 150,
                onColumnClick: this._onColumnClick,
            },
            {
                key: "column5",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketChanged")}</>}</MyContext.Consumer>,
                fieldName: "changedMs",
                minWidth: 120,
                maxWidth: 120,
                isSortedDescending: true,
                isResizable: true,
                data: "date",
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.changed}</span>;
                },
            },
            {
                key: "column6",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketTitle")}</>}</MyContext.Consumer>,
                fieldName: "title",
                minWidth: 160,
                maxWidth: 500,
                isResizable: true,
                data: "string",
                onColumnClick: this._onColumnClick,
            },
            {
                key: "column7",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketCreated")}</>}</MyContext.Consumer>,
                fieldName: "createdMs",
                minWidth: 120,
                maxWidth: 120,
                isResizable: true,
                data: "date",
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.created}</span>;
                },
            },
            {
                key: "column8",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketDetails")}</>}</MyContext.Consumer>,
                isResizable: true,
                fieldName: "description",

                minWidth: 400,
                maxWidth: 1200,
                onColumnClick: this._onColumnClick,
            },
            {
                key: "column11",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("detailContainer", "email")}</>}</MyContext.Consumer>,
                isResizable: true,
                fieldName: "contactEmail",
                minWidth: 150,
                maxWidth: 300,
                onColumnClick: this._onColumnClick,
            },
            {
                key: "column9",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketTenantName")}</>}</MyContext.Consumer>,
                isResizable: true,
                fieldName: "userId",

                minWidth: 100,
                maxWidth: 200,
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{this.tenantList[item.tenantId]}</span>;
                },
            },
            {
                key: "column10",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketTenantId")}</>}</MyContext.Consumer>,
                isResizable: true,
                fieldName: "tenantId",

                minWidth: 100,
                maxWidth: 200,
                onColumnClick: this._onColumnClick,
            },
            {
                key: "column11",
                name: <MyContext.Consumer>{(context) => <> {context.getTranslation("settings", "ticketClosedDate")}</>}</MyContext.Consumer>,
                fieldName: "closedDate",
                minWidth: 120,
                maxWidth: 120,
                isSortedDescending: true,
                isResizable: true,
                data: "date",
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.closedDate}</span>;
                },
            },
        ];
        let resultColumns = columns;
        resultColumns = settingsColumns
            .map((c) => {
                return resultColumns.filter((col) => col.fieldName === c)[0];
            })
            .filter((d) => d !== undefined);
        this.setState({
            columns: resultColumns,
            allColumns: columns,
            settingsColumns,
        });
    }

    _dialogClose = () => this.setState({ isDialogOpen: false });

    _onExport = (ev) => {
        var itemList = [];
        itemList.push(config.sheet.data[0].slice());
        this.userData.forEach((anItem) => {
            itemList.push([
                {
                    value: anItem.title,
                    type: "string",
                },
                {
                    value: anItem.created,
                    type: "string",
                },
                {
                    value: anItem.changed,
                    type: "string",
                },
                {
                    value: anItem.closedDate,
                    type: "string",
                },
                {
                    value: anItem.priority === "SOS" ? "SOS" : anItem.priority === "Critical" ? "Prio 1" : anItem.priority === "Major" ? "Prio 2" : "Prio 3",
                    type: "string",
                },
                {
                    value: anItem.caseId,
                    type: "string",
                },
                {
                    value: anItem.state,
                    type: "string",
                },
                {
                    value: anItem.tenantId,
                    type: "string",
                },
                {
                    value: anItem.description,
                    type: "string",
                },
                {
                    value: anItem?.contactEmail,
                    type: "string",
                },
                {
                    value: anItem?.tenantName,
                    type: "string",
                },
            ]);
        });
        config.sheet.data = itemList;
        zipcelx(config);
        this.setState({ isDialogOpen: true });
    };

    _onItemInvoked = (item) => {
        this.TicketListOverlayRef.current.showPanelItem(item);
        this.TicketListOverlayRef.current.fetchTicketDocuments(item.id);
    };

    // Helper to determine if any filter is active
    isFilterActive = () => {
        if (!this.props.filter) return false;
        return true;
    };

    // Add close panel function
    handleFilterPanelDismiss = () => {
        this.setState({ filterPanelOpen: false });
    };
   
    // Data for CommandBar
    getItems = () => {
        let addbutton = {
            key: "add",
            name: "Add Ticket",
            onClick: () => {
                this.props.func(null, 1);
            },
            iconProps: {
                iconName: "Add",
            },
        };

        let searchField = {
            key: "text",
            name: "text",
            onRender: () => {
                return (    
                    <div style={{ padding: "4px", display: "inline-flex" }}>
                        <TextField onChange={this._onChangeText} />
                        <Icon
                            style={{ padding: "7px", cursor: "pointer", fontSize: 18 }}
                            iconName={this.isFilterActive() ? "FilterSolid" : "Filter"}
                            title="Filter"
                            aria-label="Filter"
                            onClick={() => this.setState({ filterPanelOpen: true })}
                        />
                    </div>
                );
            },
        };

        let download = {
            key: "download",
            iconProps: { iconName: "Download" },
            name: "Export Report",
            onClick: () => {
                this._onExport();
            },
        };
        let columnSettings = {
            key: "settings",
            name: "Column Settings",
            onRender: () => {
                return (
                    <SettingsColumnsTicket
                        settingsColumns={this.state.settingsColumns}
                        allColumns={this.state.allColumns}
                        updateColumnsSettings={this.updateColumnsSettings}
                        apol={this.props.apol}
                    />
                );
            },
        };

        if (this.props.userRules.ruleAccess.confTicket) {
            return [addbutton, searchField, download, columnSettings];
        } else if (this.props.userRules.access == null || this.props.userRules.access == "Administrator" || this.props.userRules.access == "") {
            return [];
        } else {
            return [download, columnSettings];
        }
    };

    render() {
        const { columns, isModalSelection } = this.state;
        const gridStyles: Partial<IDetailsListStyles> = {
            root: {
                overflowX: "scroll",
                selectors: {
                    "& [role=grid]": {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        height: window.innerHeight - 160,
                    },
                },
            },
            headerWrapper: {
                flex: "0 0 auto",
            },
            contentWrapper: {
                flex: "1 1 auto",
                overflowY: "auto",
                overflowX: "hidden",
            },
        };
        this.ruleData = this.props.ruleData;
        this.userData = this._generateDocuments(this.props.data, this.state.filter);
        this.tenantList = this._generateTenantList(this.props.userRules);
        return (
            <MyContext.Consumer>
                {(context) => (
                    <Fabric>
                        <TicketListOverlay
                            ref={this.TicketListOverlayRef}
                            authorization={this.props.authorization}
                            apol={this.props.apol}
                            userRules={this.props.userRules}
                        />
                        <Dialog
                            isOpen={this.state.isDialogOpen}
                            type={DialogType.close}
                            onDismiss={this._dialogClose.bind(this)}
                            title="Excel export"
                            subText="Excel file created and downloaded to your favourite directory"
                            isBlocking={false}
                            closeButtonAriaLabel="Close"
                        />
                        <div className={classNames.controlWrapper}></div>
                        <CommandBar items={this.getItems()} ariaLabel={context.getTranslation("common", "navigateBetweenCommands")} />

                        <FilterPanelTicket
                            isOpen={this.state.filterPanelOpen}
                            onDismiss={this.handleFilterPanelDismiss}
                            onApply={this.props.searchFunction}
                            filter={this.props.filter}
                            withSave={this.props.withSave}
                        />

                        <MarqueeSelection selection={this._selection}>
                            <DetailsList
                                styles={gridStyles}
                                items={this.userData}
                                compact={false}
                                columns={columns}
                                selectionMode={isModalSelection ? SelectionMode.multiple : SelectionMode.none}
                                setKey="set"
                                layoutMode={DetailsListLayoutMode.justified}
                                isHeaderVisible={true}
                                selection={this._selection}
                                selectionPreservedOnEmptyClick={true}
                                enterModalSelectionOnTouch={true}
                                ariaLabelForSelectionColumn="Toggle selection"
                                ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                onRenderRow={(props, defaultRender) =>
                                    defaultRender({
                                        ...props,
                                        onClick: (event) => {
                                            event.preventDefault();
                                            this._onItemInvoked(props.item);
                                        },
                                    })
                                }
                            />
                        </MarqueeSelection>
                    </Fabric>
                )}
            </MyContext.Consumer>
        );
    }
    updateColumnsSettings = (columns) => {
        this.setState({ columns });
    };

    componentDidUpdate(previousProps: any, previousState: IDetailsListDocumentsExampleState) {
        if (previousState.isModalSelection !== this.state.isModalSelection && !this.state.isModalSelection) {
            this._selection.setAllSelected(false);
        }
    }

    _onChangeCompactMode = (ev: React.MouseEvent<HTMLElement>, checked: boolean): void => {
        this.setState({ isCompactMode: checked });
    };

    _onChangeModalSelection = (ev: React.MouseEvent<HTMLElement>, checked: boolean): void => {
        this.setState({ isModalSelection: checked });
    };

    _onChangeText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {
        this.userData = this.userData.filter((i) => i.title.includes(text) || i.title.toLocaleLowerCase().includes(text));
        this.setState({ filter: text });
    };

    openMultySelect = () => {
        console.log(this._selection.getSelection());
        if (this._selection.getSelection().length > 0) {
            this.props.func(this._selection.getSelection(), 0);
        }
    };

    _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return "";
            case 1:
                return "";
            default:
                return `${selectionCount} Items selected`;
        }
    }

    _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { columns } = this.state;
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.filter((currCol) => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        this.setState({
            columns: newColumns,
        });
    };

    _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
        const key = columnKey;
        return items.slice(0).sort((a: T, b: T) => {
            if (key === "state") {
                // Custom sort logic for state
                const stateOrder = [
                    "New",
                    "InProgress",
                    "Queued",
                    "Waiting",
                    "QueuedRnD",
                    "930760004",
                    "WaitingForSoftwareRelease",
                    "Reopened",
                    "Resolved",
                    "Solved",
                    "Canceled",
                    "Closed",
                ]; // Define your state order here
                const aIndex = stateOrder.indexOf(a[key]);
                const bIndex = stateOrder.indexOf(b[key]);
                return (isSortedDescending ? aIndex < bIndex : aIndex > bIndex) ? 1 : -1;
            } else {
                return (isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1;
            }
        });
    }

    _generateDocuments(DataArr, text) {
        // First filter
        let DataArrFiltered = DataArr.filter(
            (i) =>
                i.title.includes(text) ||
                i.title.toLocaleLowerCase().includes(text) ||
                i.caseId.includes(text) ||
                i.caseId.toLocaleLowerCase().includes(text) ||
                i.description.includes(text) ||
                i.description.toLocaleLowerCase().includes(text) ||
                (this.tenantList[i.tenantId] != undefined &&
                    (this.tenantList[i.tenantId].includes(text) || this.tenantList[i.tenantId].toLocaleLowerCase().includes(text))) ||
                i.state.includes(text) ||
                i.state.toLocaleLowerCase().includes(text)
        );
        // Then sort
        let newColumns = this.state.columns;
        newColumns.forEach((newCol: IColumn) => {
            if (newCol.isSorted) {
                DataArrFiltered = this._copyAndSort(DataArrFiltered, newCol.fieldName, newCol.isSortedDescending);
            }
        });
        return DataArrFiltered;
    }

    _generateTenantList = (userRules) => {
        let tenantList = [];
        if (userRules.allowedTenants != null) {
            userRules.allowedTenants.forEach((aTenant) => {
                tenantList[aTenant.id] = aTenant.name;
            });
        }
        return tenantList;
    };
}
